module.exports = __webpack_public_path__ + "static/media/error_bee.f9177342.png";